'use strict';

/**makes an object draggable. Takes numbers to manipulate what's seen when dragging. Use as draggable="object"*/

angular.module('posApp').directive('draggable', (dragItem) => ({
  restrict: 'A',

  link: function ($scope, $element, $attrs) {
    $element.bind('vmousedown', (event) => {
      event.preventDefault();
      dragItem.drag($scope.$apply($attrs.draggable), {
        element: $element,
        dragElement: true,
      });
    });
  },
}));
